// Content licensing — the machine- and human-readable signal that tells other
// blogs whether (and how) they may republish a post.
//
// The site default is CC BY 4.0: our own articles are free to repost with
// attribution. Third-party material we host with permission (e.g. a publication's
// interview republished with approval) is NOT ours to relicense, so those posts
// override `license: all-rights-reserved` in their frontmatter.
//
// Dependency-free so the blog schema and the Node/Bun generator scripts can import it.

export const LICENSE_IDS = ["cc-by-4.0", "all-rights-reserved"] as const;

export type LicenseId = (typeof LICENSE_IDS)[number];

/** z.enum-compatible non-empty tuple. */
export const licenseIds = LICENSE_IDS as unknown as [LicenseId, ...LicenseId[]];

export const SITE_DEFAULT_LICENSE: LicenseId = "cc-by-4.0";

export type LicenseInfo = {
  /** Short human-readable label, e.g. "CC BY 4.0". */
  label: string;
  /** Canonical license deed URL; undefined when there is nothing to link to. */
  url?: string;
  /** SPDX identifier where one exists. */
  spdx?: string;
  /** Whether third parties may republish under the license's own terms. */
  republishable: boolean;
};

export const LICENSES: Record<LicenseId, LicenseInfo> = {
  "cc-by-4.0": {
    label: "CC BY 4.0",
    url: "https://creativecommons.org/licenses/by/4.0/",
    spdx: "CC-BY-4.0",
    republishable: true,
  },
  "all-rights-reserved": {
    label: "All rights reserved",
    republishable: false,
  },
};

export function resolveLicense(id: LicenseId = SITE_DEFAULT_LICENSE): LicenseInfo {
  return LICENSES[id] ?? LICENSES[SITE_DEFAULT_LICENSE];
}
